'use strict';

angular.module('shiftTraderApp')
  .directive('scrollLeft', function ($interval, $timeout) {
    return {
      restrict: 'A',
      scope: {
        selector: '@scrollLeft',
        direction: '@'
      },
      link: function postLink(scope, element) {
        var scrollInterval;
        var initialEntranceTimer;
        var speed = 11; // easy tweaking!
        speed = speed * (scope.direction === 'right' ? 1 : -1);
        var selectedElem = $(scope.selector);
        var lastScrollLeftVal;
        var currScrollLeftVal;

        var showYourself = function() {
          element.addClass('hover');
        };

        var hideYourself = function() {
          element.removeClass('hover');
        };

        var doTheScrolling = function() {
          scrollInterval = $interval(function () {
            currScrollLeftVal = selectedElem.scrollLeft();

//            console.log(currScrollLeftVal, lastScrollLeftVal);
            if (currScrollLeftVal !== lastScrollLeftVal) {
              lastScrollLeftVal = _.clone(currScrollLeftVal);
              selectedElem.scrollLeft(selectedElem.scrollLeft() + speed);
            } else {
//              console.log('cancel that interval!');
              $interval.cancel(scrollInterval);
            }
          }, 30);
        };

        $(element).mouseenter(function () {
          initialEntranceTimer = $timeout(function() {
//            console.log('startScrolling!');
            doTheScrolling();
            showYourself();
          }, 300);
        });

        $(element).mouseleave(function () {
//          console.log('stop everything!');
          $timeout.cancel(initialEntranceTimer);
          $interval.cancel(scrollInterval);
          hideYourself();
        });
      }
    };
  });
